export function el(tag, opts = {}, children = []) {
  const node = document.createElement(tag);
  Object.entries(opts).forEach(([key, value]) => {
    if (key === 'class') node.className = value;
    else if (key === 'dataset') Object.entries(value).forEach(([k, v]) => { node.dataset[k] = v; });
    else if (key.startsWith('on') && typeof value === 'function') node.addEventListener(key.slice(2).toLowerCase(), value);
    else node.setAttribute(key, value);
  });
  children.forEach((child) => node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child));
  return node;
}

export function editable(value, placeholder) {
  const node = el('div', { class: 'at-editable', contenteditable: 'true', dataset: { placeholder: placeholder || '' } });
  node.innerHTML = value || '';
  return node;
}

export function input(value, placeholder) {
  const node = el('input', { class: 'at-input', type: 'text', placeholder: placeholder || '' });
  node.value = value || '';
  return node;
}
